import React from 'react';
import { Modal, Box, CloseButton } from '@mantine/core';

interface ImageModalProps {
  opened: boolean;
  onClose: () => void;
  src: string;
  alt: string;
}

export const ImageModal: React.FC<ImageModalProps> = ({
  opened,
  onClose,
  src,
  alt
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="xl"
      centered
      padding={0}
      withCloseButton={false}
      styles={{
        content: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.9)'
        }
      }}
    >
      <Box
        style={{
          position: 'relative',
          width: '100%',
          maxHeight: '90vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CloseButton
          size="lg"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '-50px',
            right: '0px',
            zIndex: 1000,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: 'white',
            borderRadius: '50%',
            border: '2px solid rgba(255, 255, 255, 0.3)'
          }}
        />
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: '100%',
            maxHeight: '90vh',
            objectFit: 'contain',
            borderRadius: '8px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)'
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Box>
    </Modal>
  );
};

export default ImageModal; 